export default "__VITE_ASSET__cfce7037__"